export const DEBT_TYPES = Object.freeze({
    ANY: 'any',
    EXPEDITORS: 'expeditors',
    DOCS: 'docs',
});
